import {
  CONSOLE_RESET_STATE,
  CONSOLE_RESET_STATE_SUCCESSFUL,
  CONSOLE_RESET_STATE_FAILED,
  CONSOLE_COMPANY_LIST,
  CONSOLE_COMPANY_LIST_SUCCESSFUL,
  CONSOLE_COMPANY_LIST_FAILED,
  CONSOLE_SIGNUP_LIST,
  CONSOLE_SIGNUP_LIST_SUCCESSFUL,
  CONSOLE_SIGNUP_LIST_FAILED,
  CONSOLE_COPY,
  CONSOLE_COPY_SUCCESSFUL,
  CONSOLE_COPY_FAILED,
  CONSOLE_SHARE,
  CONSOLE_SHARE_SUCCESSFUL,
  CONSOLE_SHARE_FAILED,
  CONSOLE_SMS,
  CONSOLE_SMS_SUCCESSFUL,
  CONSOLE_SMS_FAILED,
  CONSOLE_RESPONSE_RESET_STATE,
  CONSOLE_RESPONSE_RESET_STATE_SUCCESSFUL,
  CONSOLE_RESPONSE_RESET_STATE_FAILED,
  CONSOLE_INVITE_SHARE,
  CONSOLE_INVITE_SHARE_SUCCESSFUL,
  CONSOLE_INVITE_SHARE_FAILED,
  CONSOLE_INVITE_SMS,
  CONSOLE_INVITE_SMS_SUCCESSFUL,
  CONSOLE_INVITE_SMS_FAILED,
  CONSOLE_CONNECT,
  CONSOLE_CONNECT_SUCCESSFUL,
  CONSOLE_CONNECT_FAILED,
} from "./actionTypes"

const initialState = {
  companylist: {},
  companylistError : false,
  signupList: {},
  signupListError: false,
  error: false,
  loading: false,
  response: false,
  shareError : false,
  smsError : false,
  shareInviteError : false,
  smsInviteError : false,
  shareInviteResponse: false,
  smsInviteResponse: false,
  connectError : false,
  connectResponse: false,
}

const console = (state = initialState, action) => {
  switch (action.type) {
    case CONSOLE_RESPONSE_RESET_STATE:
      state = {
        ...state,
        error: false,
        loading: false,
        response: false,
        shareError : false,
        smsError : false,
        shareInviteError : false,
        smsInviteError : false,
        smsInviteResponse: false,
        shareInviteResponse: false,
        connectError : false,
        connectResponse: false,
        companylistError : false,
        signupListError: false,
      }
      break
    case CONSOLE_RESPONSE_RESET_STATE_SUCCESSFUL:
      state = {
        ...state,
        error: false,
        loading: false,
        response: false,
      }
      break
    case CONSOLE_RESPONSE_RESET_STATE_FAILED:
      state = {
        ...state,
        error: action.payload,
        loading: false,
        response: false,
      }
      break
    case CONSOLE_RESET_STATE:
      state = {
        ...state,
        list: {},
        error: false,
        loading: true,
        response: false,
      }
      break
    case CONSOLE_RESET_STATE_SUCCESSFUL:
      state = {
        ...state,
        list: {},
        error: false,
        loading: false,
        response: false,
      }
      break
    case CONSOLE_RESET_STATE_FAILED:
      state = {
        ...state,
        error: action.payload,
        list: {},
        loading: false,
        response: false,
      }
      break
    case CONSOLE_COMPANY_LIST:
      state = {
        ...state,
        error: false,
        companylist: {},
        response: false,
        loading: true,
      }
      break
    case CONSOLE_COMPANY_LIST_SUCCESSFUL:
      state = {
        ...state,
        error: false,
        companylist: action.payload,
        response: false,
        loading: false,
      }
      break
    case CONSOLE_COMPANY_LIST_FAILED:
      state = {
        ...state,
        companylistError : action.payload,
        companylist: {},
        response: false,
        loading: false,
      }
      break
      case CONSOLE_COPY:
        state = {
          ...state,
          loading: true,
          response: false,
          error: false,  
          shareError: false,
          smsError: false,   
          smsInviteResponse: false,
          shareInviteResponse: false,   
          shareInviteError: false,
          smsInviteError: false,
          connectError : false,
          connectResponse: false,
        }
        break
      case CONSOLE_COPY_SUCCESSFUL:
        state = {
          ...state,
          shareError: false,
          smsError: false,
          response: action.payload,
          loading: false,
        }
        break
      case CONSOLE_COPY_FAILED:
        state = {
          ...state,
          error: action.payload,
          response: false,
          loading: false,
        }
        break
        case CONSOLE_SHARE:
          state = {
            ...state,
            loading: true,
            response: false,
            error: false,  
            shareError: false,
            smsError: false,   
            smsInviteResponse: false,
            shareInviteResponse: false,   
            shareInviteError: false,
            smsInviteError: false,
            connectError : false,
            connectResponse: false,
          }
          break
        case CONSOLE_SHARE_SUCCESSFUL:
          state = {
            ...state,
            shareError: false,
            smsError: false,
            response: action.payload,
            loading: false,
          }
          break
        case CONSOLE_SHARE_FAILED:
          state = {
            ...state,
            shareError: action.payload,
            smsError: false,
            response: false,
            loading: false,
          }
          break
        case CONSOLE_SMS:
          state = {
            ...state,
            loading: true,
            response: false,
            error: false,  
            shareError: false,
            smsError: false,   
            smsInviteResponse: false,
            shareInviteResponse: false,   
            shareInviteError: false,
            smsInviteError: false,
            connectError : false,
            connectResponse: false,
          }
          break
        case CONSOLE_SMS_SUCCESSFUL:
          state = {
            ...state,
            shareError: false,
            smsError: false,
            response: action.payload,
            loading: false,
          }
          break
        case CONSOLE_SMS_FAILED:
          state = {
            ...state,
            shareError: false,
            smsError: action.payload,
            response: false,
            loading: false,
          }
          break
          case CONSOLE_SIGNUP_LIST:
            state = {
              ...state,
              error: false,
              signupList: {},
              response: false,
              loading: true,
            }
            break
          case CONSOLE_SIGNUP_LIST_SUCCESSFUL:
            state = {
              ...state,
              error: false,
              signupList: action.payload,
              response: false,
              loading: false,
            }
            break
          case CONSOLE_SIGNUP_LIST_FAILED:
            state = {
              ...state,
              signupListError: action.payload,
              signupList: {},
              response: false,
              loading: false,
            }
            break
            case CONSOLE_INVITE_SHARE:
              state = {
                ...state,
                loading: true,
                response: false,
                error: false,  
                shareError: false,
                smsError: false,   
                smsInviteResponse: false,
                shareInviteResponse: false,   
                shareInviteError: false,
                smsInviteError: false,
                connectError : false,
                connectResponse: false,
              }
              break
            case CONSOLE_INVITE_SHARE_SUCCESSFUL:
              state = {
                ...state,
                loading: false,
                shareInviteResponse: action.payload,
              }
              break
            case CONSOLE_INVITE_SHARE_FAILED:
              state = {
                ...state,
                loading: false,
                shareInviteError: action.payload,
              }
              break
              case CONSOLE_INVITE_SMS:
                state = {
                  ...state,
                  loading: true,
                response: false,
                error: false,  
                shareError: false,
                smsError: false,   
                smsInviteResponse: false,
                shareInviteResponse: false,   
                shareInviteError: false,
                smsInviteError: false,
                connectError : false,
                connectResponse: false,
                }
                break
              case CONSOLE_INVITE_SMS_SUCCESSFUL:
                state = {
                  ...state,
                  loading: false,
                  smsInviteResponse: action.payload,
                }
                break
              case CONSOLE_INVITE_SMS_FAILED:
                state = {
                  ...state,
                  loading: false,
                  smsInviteError: action.payload,
                }
                break
                case CONSOLE_CONNECT:
                  state = {
                    ...state,
                    loading: true,
                  response: false,
                  error: false,  
                  shareError: false,
                  smsError: false,   
                  smsInviteResponse: false,
                  shareInviteResponse: false,   
                  shareInviteError: false,
                  smsInviteError: false,
                  connectError : false,
                  connectResponse: false,
                  }
                  break
                case CONSOLE_CONNECT_SUCCESSFUL:
                  state = {
                    ...state,
                    loading: false,
                    connectResponse: action.payload,
                  }
                  break
                case CONSOLE_CONNECT_FAILED:
                  state = {
                    ...state,
                    loading: false,
                    connectError: action.payload,
                  }
                  break
    default:
      state = { ...state, response: false }
      break
  }
  return state
}

export default console
